/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExpenseItemDto
 */
export interface ExpenseItemDto {
  /**
   *
   * @type {string}
   * @memberof ExpenseItemDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseItemDto
   */
  fundId: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseItemDto
   */
  name: string;
}

export function ExpenseItemDtoFromJSON(json: any): ExpenseItemDto {
  return ExpenseItemDtoFromJSONTyped(json, false);
}

export function ExpenseItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseItemDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    fundId: json["fundId"],
    name: json["name"],
  };
}

export function ExpenseItemDtoToJSON(value?: ExpenseItemDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    fundId: value.fundId,
    name: value.name,
  };
}
